import { render, staticRenderFns } from "./GardenerLocationAreaRemove.vue?vue&type=template&id=023c4006&scoped=true"
import script from "./GardenerLocationAreaRemove.vue?vue&type=script&lang=js"
export * from "./GardenerLocationAreaRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023c4006",
  null
  
)

export default component.exports